import { z } from "zod";

/**
 * Slack Manifest Response Schema
 *
 * Returns the Slack app manifest JSON for creating a Slack app from a deployment.
 * This manifest is used to install the deployment as a Slack app in workspaces.
 */
export const SlackManifestSchema = z.object({
  display_information: z.object({
    name: z.string(),
    description: z.string(),
    long_description: z.string(),
    background_color: z.string().optional(),
    icon_url: z.string().url().optional()
  }),
  features: z.object({
    app_home: z.object({
      messages_tab_enabled: z.boolean(),
      messages_tab_read_only_enabled: z.boolean()
    }),
    bot_user: z.object({
      display_name: z.string(),
      always_online: z.boolean()
    })
  }),
  settings: z.object({
    event_subscriptions: z.object({
      request_url: z.string().url(),
      bot_events: z.array(z.string())
    })
  }),
  oauth_config: z.object({
    redirect_urls: z.array(z.string().url()).optional(),
    scopes: z.object({
      user: z.array(z.string()).optional(),
      bot: z.array(z.string())
    })
  })
});

export type SlackManifest = z.infer<typeof SlackManifestSchema>;

export const SlackManifestResponseSchema = z.object({
  manifest: SlackManifestSchema,
  pendingConnectionId: z.string().uuid()
});

export type SlackManifestResponse = z.infer<typeof SlackManifestResponseSchema>;

/**
 * Get Slack Manifest Path Variables Schema
 */
export const GetSlackManifestPathVarsSchema = z.object({
  id: z.string().uuid()
});

export type GetSlackManifestPathVars = z.infer<typeof GetSlackManifestPathVarsSchema>;
